var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChecklistDailyView',{attrs:{"view-only":_vm.isViewOnlyUser},on:{"update-completed":function($event){return _vm.$emit('update-completed', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }